var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.topmenu)?_c('v-app-bar',{staticClass:"body-2",attrs:{"height":"56","center":"","fixed":"","app":""}}):_vm._e(),_c('v-content',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }